import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from "react-router-dom"
import { SimpleGrid, Box, Button, Flex, Image, Text, Card, CardHeader, Heading, InputGroup, Input, InputRightElement } from '@chakra-ui/react'
import Layout from '../layout'
import { fetchActiveBolsa } from "../actions"
import { getBolsa } from "../reducers"

const BolsaEmpleoView = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchActiveBolsa())
    }, [])

    const [post_id] = useState(useParams("id").id)
    const post = useSelector(state => getBolsa(state, post_id))

    let time = new Date(post.updated_at)

    return (
        <Layout>
            <Box bg={"easycar2.300"} color={"white"} p={3} mb={3}>
                <Flex maxW={"1400px"} minH={"200px"} flexDir={"column"} justifyContent={"center"} m={"auto"}>
                    <Heading>
                        {post.title}
                    </Heading>
                    Publicado: {time.toLocaleDateString()}
                </Flex>
            </Box>
            <Flex maxW={"1400px"} flexDir={'column'} p={4} m={"auto"} mt={"2rem"} mb={"2rem"}>
                <div className="blogContent" dangerouslySetInnerHTML={{ __html: post.description }} />
                <br/>
                <Link to={`/bolsa-empleo/${post.id}/postular`}>
                    <Button colorScheme="easycar1" >Postular ahora</Button>
                </Link>
            </Flex>
        </Layout >
    )
}

export default BolsaEmpleoView